module.exports = __webpack_public_path__ + "static/media/mental-awareness.56e00a25.svg";